import React from 'react';

import CustomComponent from '../CustomComponent';

import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './DynamicVesselCustomComponent.less';


const vesselCheckIfCount = (compData) => {
  // 标记是否有计数器组件
  let flag = false;
  let types = {
    'count-ele': true,
    'new-count': true,
  };
  const checkHasEle = (ele) => {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (types[ele.type]) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      for (let subEle of ele.content) {
        checkHasEle(subEle);
      }
    } else if (ele.type === 'layout-vessel') { // 双栏组件的content不为数组
      for (let attr of Object.keys(ele.content)) {
        for (let subEle of ele.content[attr]) {
          checkHasEle(subEle);
        }
      }
    }
  }
  checkHasEle(compData);
  if (flag) {
    return 1;
  }
  return 0;
}

export default class DynamicVesselCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex]; // 后续更更改为this.props.data
    let customFeature = compData.customFeature;
    let param = {
      id: customFeature['id'],
      form: customFeature['form'],
      page: 1,
      app_id: app.getAppId(),
      is_count: vesselCheckIfCount(compData), // TODO 当前容器中是否有计数器组件
      param_segment: customFeature['param_segment'],
      search_segment: customFeature['search_segment'],
    };
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });
  }

  detailPageInit = (compindex, pageInstance, formdata) => {
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let oldParam = compData.param || {};
    let vessel_param = {
      "form": customFeature.form,
      "is_count": oldParam.is_count,
      "page": 1,
      "param_segment": customFeature.param_segment,
      "search_segment": customFeature.search_segment
    };

    if (vessel_param.param_segment === 'id') {
      vessel_param.idx = vessel_param.search_segment;
      vessel_param.idx_value = pageInstance.dataId;
    } else if (!!formdata[vessel_param.param_segment]) {
      vessel_param.idx = vessel_param.search_segment;
      vessel_param.idx_value = formdata[vessel_param.param_segment];
    } else {
      return;
    }
    let dynewdata = {};
    dynewdata['eles[' + compindex + '].loading'] = true;
    dynewdata['eles[' + compindex + '].loadingFail'] = false;
    dynewdata['eles[' + compindex + '].list_data'] = [];
    dynewdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(dynewdata);
    app.sendRequest({
      hideLoading: true,   // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      data: {
        form: vessel_param.form,
        page: 1,
        idx_arr: {
          idx: vessel_param.idx,
          idx_value: vessel_param.idx_value
        }
      },
      method: 'post',
      chain: true,
      success: function (res) {
        let newDynamicData = {};

        if (!res.data.length) {
          newDynamicData['eles[' + compindex + '].is_more'] = 0;
          newDynamicData['eles[' + compindex + '].loading'] = false;
          newDynamicData['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newDynamicData);
          return;
        }

        if (vessel_param.form !== 'form') { // 动态列表绑定表单则不调用富文本解析
          for (let j in res.data) {
            for (let k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if(/region/.test(k)){
                continue;
              }
              if(k == 'goods_model') {
                res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
              }

              let description = res.data[j].form_data[k];
            }
          }
        }

        newDynamicData['eles[' + compindex + '].list_data'] = res.data;
        newDynamicData['eles[' + compindex + '].is_more'] = res.is_more || 0;
        newDynamicData['eles[' + compindex + '].curpage'] = res.current_page;
        newDynamicData['eles[' + compindex + '].loading'] = false;
        newDynamicData['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newDynamicData);
      },
      fail: function () {
        let dynewdata2 = {};
        dynewdata2['eles[' + compindex + '].loadingFail'] = true;
        dynewdata2['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dynewdata2);
      }
    });

  }

  dynamicVesselScrollFunc = (event) => {
    let pageInstance  = app.getAppCurrentPage();
    let compindex        = event.target.dataset.compindex;
    let compData      = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let curpage       = compData.curpage + 1;
    let newdata       = {};
    let param         = {};

    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    if (customFeature.param_segment === 'id') {
      param.idx = customFeature.search_segment;
      param.idx_value = pageInstance.dataId;
    } else if (!!pageInstance.data.detailData[customFeature.param_segment]) {
      param.idx = customFeature.search_segment;
      param.idx_value = pageInstance.data.detailData[customFeature.param_segment];
    }

    app.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      data: {
        form: customFeature.form,
        page: curpage,
        idx_arr: {
          idx: param.idx,
          idx_value: param.idx_value
        }
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        newdata = {};
        for (let j in res.data) {
          for (let k in res.data[j].form_data) {
            if (k == 'category') {
              continue;
            }
            if(/region/.test(k)){
              continue;
            }
            if(k == 'goods_model') {
              res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
            }

            let description = res.data[j].form_data[k];

          }
        }
        newdata['eles[' + compindex + '].list_data'] = compData.list_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {

      }
    })
  }

  // 动态容器跳转（应该跟动态列表是同一个跳转函数，暂时分成两个）
  dynamicVesselTurnToPage = (event) => {
    let dataset = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let data_id = dataset.dataid;
    let router = dataset.router;
    let page_form = pageInstance.page_form;
    let isGroup = dataset.isGroup;
    let isSeckill = dataset.isSeckill;
    let compindex = dataset.compindex;
    let index = dataset.index;
    let list = pageInstance.data.eles[compindex].list_data[index];
    let form_data = list.form_data || list;

    if (router == '' || router == -1 || router == '-1') {
      return;
    }

    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (isGroup && isGroup == 1) {
      app.turnToPage('groupGoodsDetail?detail=' + data_id + chainParam);
      return;
    }
    if (isSeckill && isSeckill == 1) {
      app.turnToPage('goodsDetail?detail=' + data_id + '&goodsType=seckill' + chainParam);
      return;
    }
  
    if (page_form != '') {
      if (router == 'tostoreDetail') {
        app.turnToPage('toStoreDetail?detail=' + data_id + chainParam);
      } else if (router == 'goodsDetail') {
        app.turnToPage('goodsDetail?detail=' + data_id + chainParam);
      } else if (router == 'videoDetail') {
        app.turnToPage('videoDetail?detail=' + data_id + chainParam);
      } else if (router == 'franchiseeDetail') {
        let mode = form_data.mode_id;
        app.goToFranchisee(mode, {
          detail: data_id
        });
      } else if (router == 'presellDetail') {
        app.turnToPage(router + '?detail=' + data_id)
      } else{
        app.turnToPage(router + '?detail=' + data_id);
      }
    }

  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 组件内容处理
     */  
    const content = data.content;
    /**
     * 返回组件
     */ 
    return (
      <div className="custom-component dynamic-vessel" style={styleObj}>
        {
          data.list_data && data.list_data.map((item, index) => (
            <div className="dynamic-vessel-item" key={index}
              onClick={this.dynamicVesselTurnToPage}
              data-compindex={this.props.index}
              data-index={index}
              data-dataid={item.id || (item.form_data.id && item.form_data.id[0] && item.form_data.id)}
              data-router={data.customFeature.link}
              data-is-group={item.form_data.is_group_buy}
              data-is-seckill={item.form_data.is_seckill && item.form_data.is_seckill[0] && item.form_data.is_seckill}
              >
              {content.map((componentData, componentIndex) => 
                <CustomComponent key={componentIndex} index={componentIndex} data={componentData} dynamicData={item['form_data']}></CustomComponent>  
              )}
            </div>
          ))
        }
        {/* 加载loading */}
        {
          data.loading && 
          <RequestStatus is="requestLoading"></RequestStatus>
        }
        {/* 加载没有数据 */}
        {
          data.is_more == 0 && data.list_data.length == 0 &&
          <RequestStatus is="requestNone" data={{ data: '暂无数据~'}}></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.loadingFail &&
          <RequestStatus is="requestFail" data={{refreshEvent: 'dynamicVesselScrollFunc', compindex: this.props.index}}></RequestStatus>
        }
        {/* 加载完所有数据 */}
        {
          data.is_more == 0 && data.list_data.length > 0 && data.customFeature.isShowFinishText &&
          <RequestStatus is="requestAll"></RequestStatus>
        }
        {/* 点击加载按钮 */}
        {
          !!(data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail) &&
          <LoadingBtn customFeature={data.customFeature} onClick={this.dynamicVesselScrollFunc} data-compindex={this.props.index}></LoadingBtn>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/dynamic-vessel-custom-component/DynamicVesselCustomComponent.jsx